import { Prop, Vue, Watch } from 'vue-property-decorator';
import { WatchOptions } from 'vue';

export default abstract class InputBase<T> extends Vue {
  @Prop({ required: true }) public name?: string;
  @Prop() public label?: string;
  @Prop() public placeholder?: string;
  @Prop() public min?: string;
  @Prop({ default: false }) public required?: boolean;
  @Prop({ default: false }) public disabled?: boolean;
  @Prop({ default: false }) public readonly?: boolean;
  @Prop() public value?: T;
  public randomId: string = Math.floor(Math.random() * Math.floor(100000000)).toString();
  protected inputType: string = 'text';

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: T, oldValue: T) {
    // tslint:disable-line:no-empty
  }
}
